import React from "react";
import { useSelector } from "react-redux";
import classes from './WarningPopup.module.css'
import BackdropPopup from '../../../../../lms-shared/UI/Popups/BackdropPopup/BackdropPopup';
import closeIcon from '../../../../../../assests/learning-tracking/teams/close.png'

const WarningPopup = ({ children, title, content, footerContent, dropClass, cancel, confirm, myWidth = '500px', myHeight = '300px', headerTitle, setPopup }) => {

    const texts = useSelector(state => state.translate.texts);

    return (
        <BackdropPopup myHeight={myHeight} myWidth={myWidth}>
            <div className={classes.PopupContainer}>
                <img src={closeIcon} alt="Close" className={classes.CloseIcon} onClick={setPopup} />
                <div className={classes.Header}>
                    <p>{headerTitle}</p>
                </div>
                <div className={classes.PopupTitle}>{title}</div>
                <div className={`${classes.PopupContent} ${dropClass}`}>{content}</div>
                {children}
                <div className={`${classes.PopupContent} ${dropClass}`}>{footerContent}</div>
            </div>
        </BackdropPopup>
    )
}

export default WarningPopup;